export const UPLOAD_MAX_FILES = 20;
export const UPLOAD_MAX_FILE_SIZE_MB = 20;

export const UPLOAD_EXTENSIONS: string[] = [
	'pdf',
	'xls',
	'xlsx',
	'doc',
	'docx',
	'txt',
	'csv',
	'notes',
];
